module.exports = __webpack_public_path__ + "static/Refinance-0ca7bbd987106b079311d9efd380926e.png";